package com.anjuros.website.redesign.sections.pricing

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.PricingIncludedGridStyle
import com.anjuros.website.redesign.styles.PricingIncludedBandStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val Included = listOf(
    RdText.PRICING_INC1_TITLE to RdText.PRICING_INC1_TEXT,
    RdText.PRICING_INC2_TITLE to RdText.PRICING_INC2_TEXT,
    RdText.PRICING_INC3_TITLE to RdText.PRICING_INC3_TEXT,
)

/** What every website gets, whichever option is chosen; on the pale-blue band. */
@Composable
fun PricingIncludedSection() {
    RdSection(id = "included", labelledBy = "included-h", modifier = RdSectionStyle.toModifier().then(PricingIncludedBandStyle.toModifier())) {
        RdSectionHead(RdText.PRICING_INCLUDED_EYEBROW, "included-h", RdText.PRICING_INCLUDED_TITLE, RdText.PRICING_INCLUDED_LEDE)
        Div(PricingIncludedGridStyle.toModifier().toAttrs()) {
            Included.forEach { (title, text) ->
                Div {
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                    P { Text(LocalText(text)) }
                }
            }
            Div {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(RdText.PRICING_INC4_TITLE)) }
                P {
                    Text(LocalText(RdText.PRICING_INC4_TEXT))
                    RdLink(RdRoute.CONTACT_FORMS) { Text(LocalText(RdText.PRICING_INC4_LINK)) }
                }
            }
        }
    }
}
